export enum Quadrant {
  TopLeftQuadrant = "TopLeftQuadrant",
  TopRightQuadrant = "TopRightQuadrant",
  BottomLeftQuadrant = "BottomLeftQuadrant",
  BottomRightQuadrant = "BottomRightQuadrant"
}
